/* Mikaya — quick variant picker popup for product cards.
   Opens from [data-mk-variant], lists variants as add buttons (reusing the
   global [data-mk-atc] add handler in mk-cart.js), then closes + opens cart. */
(function () {
  var pop = document.querySelector('[data-mk-vp]');
  if (!pop) return;
  var titleEl = pop.querySelector('[data-mk-vp-title]');
  var optsEl = pop.querySelector('[data-mk-vp-options]');
  var linkEl = pop.querySelector('[data-mk-vp-link]');

  function openPop() {
    pop.hidden = false;
    pop.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mk-vp-open');
  }
  function closePop() {
    pop.hidden = true;
    pop.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mk-vp-open');
  }

  document.addEventListener('click', function (e) {
    // open
    var trigger = e.target.closest('[data-mk-variant]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var dataEl = trigger.parentNode.querySelector('.mk-variant-data');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
      titleEl.textContent = data.title || '';
      linkEl.setAttribute('href', data.url || '#');
      var thumb = pop.querySelector('[data-mk-vp-thumb]');
      if (thumb) {
        if (data.image) { thumb.src = data.image; thumb.hidden = false; }
        else { thumb.hidden = true; }
      }
      optsEl.innerHTML = '';
      (data.variants || []).forEach(function (v) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mk-vp__opt' + (v.available ? '' : ' is-soldout');
        if (v.available) { btn.setAttribute('data-mk-atc', ''); btn.setAttribute('data-variant-id', v.id); }
        else { btn.disabled = true; }
        btn.innerHTML = '<span>' + v.title + '</span><span class="mk-vp__opt-price">' + (v.available ? v.price : 'Sold out') + '</span>';
        optsEl.appendChild(btn);
      });
      openPop();
      return;
    }
    // close
    if (e.target.closest('[data-mk-vp-close]')) { e.preventDefault(); closePop(); return; }
    // after an option is added (mk-cart.js handles the actual add), close the popup
    if (e.target.closest('[data-mk-vp-options] [data-mk-atc]')) {
      setTimeout(closePop, 350);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pop.hidden) closePop();
  });
})();
